import { render } from "./Header.vue?vue&type=template&id=2cad83eb&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=2cad83eb&scoped=true&lang=scss"

import exportComponent from "/Users/wangwangxinkai/Documents/PBM/tianke-1/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cad83eb"]])

export default __exports__